import { render, staticRenderFns } from "./PaymentSaleCompletedPage.vue?vue&type=template&id=4663bd5f&"
import script from "./PaymentSaleCompletedPage.vue?vue&type=script&lang=js&"
export * from "./PaymentSaleCompletedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports